import { TemplateVariableDefinitionDto } from '@/features/dashboard/messageTemplates/types/TemplateVariableDefinitionDto.ts';
import { isBlockVariable } from '../templateVariableUtils.ts';
import { convertTemplateToTiptap } from './templateToTiptap.ts';

// Wraps a plain-text template (one line per `<p>`) as HTML so the shared
// `convertTemplateToTiptap` core can do the `{{key}}` → marker substitution.
// Block-typed variables are stripped — plain-text contexts (SMS body, email
// subject) can't host HTML-table chips.
export const convertPlainTextToTiptap = (
  text: string | null | undefined,
  variables: TemplateVariableDefinitionDto[] = [],
): string => {
  // Tolerate nullish input — backend default templates may return null
  const safeText = text ?? '';
  const wrappedHtml = safeText
    .split('\n')
    .map((line) => `<p>${escapeForHtml(line) || '<br>'}</p>`)
    .join('');

  const inlineVariables = variables.filter((v) => !isBlockVariable(v));
  return convertTemplateToTiptap(wrappedHtml, inlineVariables);
};

const escapeForHtml = (text: string): string =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
